export default function stripPersonalDataFromUrlsInClipboard(e) {
    var _a, _b;
    // Get the selected range
    var selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
        var range = selection.getRangeAt(0);
        // Clone the selected content into a temporary element
        var tempDiv = document.createElement('div');
        tempDiv.appendChild(range.cloneContents());
        // Iterate through the <a> tags and modify the href attributes
        var links = tempDiv.querySelectorAll('a');
        if (!links || links.length === 0) {
            return;
        }
        links.forEach(function (link) {
            var url = new URL(link.href);
            url.searchParams.delete('name');
            url.searchParams.delete('email');
            url.searchParams.delete('phone');
            link.href = url.toString();
        });
        // Serialize the modified content to HTML
        var html = tempDiv.innerHTML;
        // Serialize the modified content to plain text
        var text = tempDiv.textContent || '';
        // Set the modified HTML and plain text as the clipboard data
        (_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.setData('text/html', html);
        (_b = e.clipboardData) === null || _b === void 0 ? void 0 : _b.setData('text/plain', text);
        e.preventDefault(); // Prevent the default copy action
    }
}
